"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var json_api_fetch_1 = require("./json_api_fetch");
/**
 * Fetch a link object and response in Json API format
 * @param url url to fetch
 */
function fetchInvoices() {
  return (0, json_api_fetch_1.jsonApiFetch)('invoices');
}
exports.default = fetchInvoices;